const common = {
  Loading: "加載中",
  signUp: "註冊",
  login: "登錄",
  logout: "登出",
  email: "郵箱",
  emailFormatErrorTips: "郵箱格式不正確",
  emailDifferentTips: "兩次輸入郵箱不一致",
  emailRegisteredTips: "郵箱已註冊",
  password: "密碼",
  passwordFormatErrorTips: "密碼必須為8-50個字元，並且至少包含以下兩類：數字、字母或特殊字元。",
  passwordDifferentTips: "請兩次輸入相同的密碼",
  verificationCode: "驗證碼",
  verificationCodeErrorTips: "輸入驗證碼錯誤",
  confirm: "確認",
  cancel: "取消",
  submit: "提交",
  confirmEmail: "確認郵箱",
  formEmptyErrorTips: "此處不能為空",
  country: "國家/地區",
  birthday: "生日",
  anonymous: "匿名",
  name: "名字",
  nameFormatErrorTips: "用戶名應在五十字符內且不含特殊字元",
  okBtn: "好的",
  serverErrorTips: "請求失敗，請稍後再試",
  updateSuccessTips: "修改成功",
  authorizationExpiredErrorTips: "認證資訊過期，請重新登入",
  requestFrequentlyErrorTips: "請求太過於頻繁，請稍後再試",
  GetCode:'取得程式碼'
};

export default common;
